export const SET_EMAIL_SUBSCRIPTION = 'SET_EMAIL_SUBSCRIPTION'
export const setEmailSubscription = (emailSubscription) => ({
  type: SET_EMAIL_SUBSCRIPTION,
  emailSubscription,
})

export const SET_EMAIL_SURVEY_SUBSCRIPTION = 'SET_EMAIL_SURVEY_SUBSCRIPTION'
export const setEmailSurveySubscription = (surveySubscription) => ({
  type: SET_EMAIL_SURVEY_SUBSCRIPTION,
  surveySubscription,
})



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/actions/sync/profile.js